import {
    EVENT_CREATE_EDIT_OPEN_MODAL,
    EVENT_CREATE_REQUEST,
    EVENT_CREATE_RESULT,
    EVENT_EDIT_REQUEST,
    EVENT_EDIT_RESULT,
    EVENT_GET_REQUEST,
    EVENT_GET_RESULT,
    EVENT_GET_UNIT_TYPES_REQUEST,
    EVENT_GET_UNIT_TYPES_RESULT,
} from 'Redux/actionTypes';

export const eventCreateEditOpenModal = (open, event) => ({
    type: EVENT_CREATE_EDIT_OPEN_MODAL,
    payload: { open, event }
})

export const eventCreateRequest = (data) => ({
    type: EVENT_CREATE_REQUEST,
    payload: data
})

export const eventCreateResult = (result) => ({
    type: EVENT_CREATE_RESULT,
    payload: result
})

export const eventEditRequest = (data) => ({
    type: EVENT_EDIT_REQUEST,
    payload: data
})

export const eventEditResult = (result) => ({
    type: EVENT_EDIT_RESULT,
    payload: result
})

export const eventGetRequest = (data) => ({
    type: EVENT_GET_REQUEST,
    payload: data
})

export const eventGetResult = (result) => ({
    type: EVENT_GET_RESULT,
    payload: result
})

export const eventSearchUnitTypeRequest = (data) => ({
    type: EVENT_GET_UNIT_TYPES_REQUEST,
    payload: data
})

export const eventSearchUnitTypeResult = (result) => ({
    type: EVENT_GET_UNIT_TYPES_RESULT,
    payload: result
})